import { cn } from '../../lib/cn'
import type { HTMLAttributes } from 'react'

export default function Container({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('container max-w-container px-4 sm:px-6', className)}
      {...props}
    />
  )
}
